__turbopack_context__.v({
  "carousel": "Carousel-module-scss-module__Qa6c9G__carousel",
  "carousel_nav_next": "Carousel-module-scss-module__Qa6c9G__carousel_nav_next",
  "carousel_nav_prev": "Carousel-module-scss-module__Qa6c9G__carousel_nav_prev",
  "carousel_pagination": "Carousel-module-scss-module__Qa6c9G__carousel_pagination",
  "carousel_pagination_white": "Carousel-module-scss-module__Qa6c9G__carousel_pagination_white",
  "carousel_slide": "Carousel-module-scss-module__Qa6c9G__carousel_slide",
  "carousel_wrapper": "Carousel-module-scss-module__Qa6c9G__carousel_wrapper",
});
